import { get } from "react-hook-form";
import apiApp from "./index";
const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

const getHeaders = () => {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };

    // only tenant-admin OR if subTenantId is missing
    if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
        headers["tenant-login"] = true;
    }

    return headers;
};

const getSubTenantDTO = () => {
    return decodedToken?.isMultitenancy && decodedToken?.subTenantId
        ? { id: decodedToken.subTenantId }
        : null;
};

const SensorApi = {
    // Create Sensors Api
    CreateSensors: (data) => {
        const jsonData = JSON.parse(data);
        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

        const headers = getHeaders();
        return new Promise((resolve, reject) => {
            apiApp
                .post(`/sensors`, JSON.stringify(jsonData), {
                    headers: headers,
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },
    // Put Sensors Api
    PutSensors: (SensorsID, data) => {
        const jsonData = JSON.parse(data);
        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

        const headers = getHeaders();
        return new Promise((resolve, reject) => {
            apiApp
                .put(`/sensors/${SensorsID}`, JSON.stringify(jsonData), {
                    headers: headers,
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    // Single Sensors Api
    SingleSensors: (SensorsID) => {
        const headers = getHeaders();
        return new Promise((resolve, reject) => {
            apiApp
                .get(
                    `/sensors/${SensorsID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    {
                        headers: headers,
                    }
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    // List Sensors Api
    ListSensors: (page, limit) => {
        // const headers = {
        //     Authorization: `Bearer ${token}`,
        //     "x-Authorization": `${decodedToken?.tenantApiKey}`,
        // };
        const headers = getHeaders();
        return new Promise((resolve, reject) => {
            apiApp
                .get(`/sensors?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
                    headers: headers,
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    // Delete Sensors Api
    DeleteSensors: (SensorsID) => {
        const headers = {
            Authorization: `Bearer ${token}`,
            "x-Authorization": `${decodedToken?.tenantApiKey}`,
        };
        return new Promise((resolve, reject) => {
            apiApp
                .delete(
                    `/sensors/${SensorsID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    {
                        headers: headers,
                    }
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

};

export default SensorApi;
